"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Video = void 0;
var react_1 = __importStar(require("react"));
var ElementTag_1 = __importDefault(require("../internal/ElementTag"));
exports.Video = react_1.memo(function (_a) {
    var _b = _a.as, as = _b === void 0 ? 'video' : _b, src = _a.src, alt = _a.alt, track = _a.track, children = _a.children, className = _a.className, rest = __rest(_a, ["as", "src", "alt", "track", "children", "className"]);
    if (typeof src === 'string') {
        rest.src = src;
    }
    return (react_1["default"].createElement(ElementTag_1["default"], __assign({ as: as, className: ['video', className] }, rest),
        src instanceof Array && src.map(function (s, i) { return react_1["default"].createElement("source", __assign({ key: i }, s)); }), track === null || track === void 0 ? void 0 :
        track.map(function (t, i) { return (react_1["default"].createElement("track", __assign({ key: i }, t))); }),
        alt,
        children));
});
//# sourceMappingURL=Video.js.map